<template>
    <div class="shopConfWrap">
        <el-button type="primary" @click="handlerAddConf">新增店铺价格配置</el-button>
        <div style="margin:10px 0;">
            <el-select 
                v-model="selectShop" 
                filterable 
                clearable
                placeholder="请选择店铺" 
                width="200px"
                @change="handleShopChange"
            >
                <el-option
                    v-for="item in getPlatformShops"
                    :key="item.id"
                    :label="item.shortTitle || item.title"
                    :value="item.id"
                >
                </el-option>
            </el-select>
        </div>
        <el-table
            :data="getShowTableData"
            style="width: 100%"
        >
            <el-table-column
                prop="shop"
                label="价格配置"
                width="700px"
            >
                <template slot-scope="{row}">
                    <div class="shopConItem">
                        <div class="shopConExpandBtn" @click="handlerExpand(row)">{{row.expand ? '收起' : '展开'}}配置详情</div>
                        <div :style="{height:row.expand ? 'auto' : '0',overflow:'hidden'}">
                            <el-form label-width="20%">
                                <el-form-item :label="`${priceConfName.sales}配置:`" label-width="100px">
                                <el-radio-group v-model="row.salesPrice.way">
                                    <el-radio style="line-height: 30px" label="unity">取{{  priceConfName.name }}资料保存的{{ priceConfName.sales }}</el-radio>
                                    <br />
                                    <el-radio label="formula">
                                    按公式修改： 
                                    <!-- 当前价格 -->
                                    <el-select v-model="row.salesPrice.formulaValue.priceMultiplier" width="130px">
                                        <el-option :label="priceConfName.name +  priceConfName.sales" value="now"></el-option>
                                        <el-option label="基础资料销售价" value="base_sales"></el-option>
                                        <el-option label="基础资料市场价" value="base_market"></el-option>
                                        <el-option label="基础资料成本价" value="base_purchase"></el-option>
                                        <el-option label="基础资料基本售价" value="base_base_selling"></el-option>
                                    </el-select>
                                    X
                                    <el-input-digit v-model.number="row.salesPrice.formulaValue.percentage" :precision="0" :max="999" nullable style="width: 80px">
                                        <span>%</span>
                                    </el-input-digit>
                                    +
                                    <el-input-digit v-model.number="row.salesPrice.formulaValue.addValue" :precision="2" nullable style="width: 80px">
                                        <span>元</span>
                                    </el-input-digit>
                                    -
                                    <el-input-digit v-model.number="row.salesPrice.formulaValue.subtractionValue" :precision="2" nullable style="width: 80px">
                                        <span>元</span>
                                    </el-input-digit>
                                    </el-radio>
                                </el-radio-group>
                                </el-form-item>
                                <el-form-item label="" label-width="100px">
                                <span>
                                    <span style="margin-left: 30px; font-size: 12px"> 分角处理：</span>
                                    <el-radio-group v-model="row.salesPrice.formulaValue.formula">
                                    <el-radio label="reserve">保留角和分 <span style="color: #aaa">(四舍五入)</span></el-radio>
                                    <el-radio label="erase_cent_dime">抹去分和角</el-radio>
                                    <el-radio label="erase_cent">抹去分</el-radio>
                                    <el-radio label="unity"
                                        >统一修改为xx.
                                        <el-input-digit
                                            v-model.number="row.salesPrice.formulaValue.centDime1"
                                            :precision="0"
                                            :min="0"
                                            :maxlength="1"
                                            nullable
                                            style="width: 30px"
                                        >
                                        </el-input-digit>
                                        <el-input-digit
                                            v-model.number="row.salesPrice.formulaValue.centDime2"
                                            :precision="0"
                                            :min="0"
                                            :maxlength="1"
                                            nullable
                                            style="width: 30px"
                                        >
                                        </el-input-digit>
                                        <!-- <el-input
                                        v-model="row.salesPrice.formulaValue.centDime"
                                        regexp="^[0-9]{0,2}$"
                                        :maxlength="2"
                                        style="width: 60px"
                                        >
                                        </el-input> -->
                                        元
                                    </el-radio>
                                    </el-radio-group>
                                </span>
                                </el-form-item>
                                <el-form-item label="" label-width="100px">
                                <el-checkbox v-model="row.isIncr"
                                    >是否价格递增（为防止重复铺货，多店铺铺货可设置递增金额，按店铺顺序上架链接依次递增金额）</el-checkbox
                                >
                                <p v-if="row.isIncr" style="margin-left: 30px; font-size: 12px">
                                    递增金额：<el-input-digit v-model.number="row.salesPrice.incr" :precision="2" nullable style="width: 160px">
                                    <span>元</span>
                                    </el-input-digit>
                                </p>
                                </el-form-item>
                                <el-form-item label="" label-width="100px" v-if="isDistributor">
                                    <el-checkbox v-model="row.salesPrice.isCalculateFreight">分销商品价格是否附加供销运费</el-checkbox>
                                    <div style="padding-left: 10px;" v-if="row.salesPrice.isCalculateFreight">
                                        <span style="color:#333;font-size:12px;">{{priceConfName.name}}价格 + 供销运费 X </span>
                                        <el-input-digit v-model.number="row.salesPrice.supplyFormulaValue.percentage" placeholder="请输入" nullable style="width: 60px">
                                        <span>%</span>
                                        </el-input-digit> + 
                                        <el-input-digit v-model.number="row.salesPrice.supplyFormulaValue.addValue" placeholder="请输入" nullable style="width: 60px">
                                        <span>元</span>
                                        </el-input-digit> -
                                        <el-input-digit v-model.number="row.salesPrice.supplyFormulaValue.subtractionValue" placeholder="请输入" nullable style="width: 60px">
                                        <span>元</span>
                                        </el-input-digit>
                                    </div>
                                </el-form-item>

                                <template v-if="priceConfName.market">
                                <el-form-item :label="`${priceConfName.market}配置:`" label-width="100px">
                                    <el-radio-group v-model="row.marketPrice.way">
                                    <el-radio style="line-height: 30px" label="unity">取{{ priceConfName.name }}资料保存的{{ priceConfName.market }}</el-radio>
                                    <br />
                                    <el-radio label="formula">
                                        按公式修改： 
                                        <!-- 当前价格 -->
                                        <el-select v-model="row.marketPrice.formulaValue.priceMultiplier" width="130px">
                                        <el-option :label="priceConfName.name +  priceConfName.sales" value="pdd_multi_price"></el-option>
                                        <el-option :label="priceConfName.name + priceConfName.market" value="now"></el-option>
                                        <el-option label="基础资料销售价" value="base_sales"></el-option>
                                        <el-option label="基础资料市场价" value="base_market"></el-option>
                                        <el-option label="基础资料成本价" value="base_purchase"></el-option>
                                        <el-option label="基础资料基本售价" value="base_base_selling"></el-option>
                                        </el-select>
                                        X
                                        <el-input-digit v-model.number="row.marketPrice.formulaValue.percentage" :precision="0" :max="999" nullable style="width: 80px">
                                        <span>%</span>
                                        </el-input-digit>
                                        +
                                        <el-input-digit v-model.number="row.marketPrice.formulaValue.addValue" :precision="2" nullable style="width: 80px">
                                        <span>元</span>
                                        </el-input-digit>
                                        -
                                        <el-input-digit v-model.number="row.marketPrice.formulaValue.subtractionValue" :precision="2" nullable style="width: 80px">
                                        <span>元</span>
                                        </el-input-digit>
                                    </el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="" label-width="100px">
                                    <span>
                                    <span style="margin-left: 30px; font-size: 12px"> 分角处理：</span>
                                    <el-radio-group v-model="row.marketPrice.formulaValue.formula">
                                        <el-radio label="reserve">保留角和分 <span style="color: #aaa">(四舍五入)</span></el-radio>
                                        <el-radio label="erase_cent_dime">抹去分和角</el-radio>
                                        <el-radio label="erase_cent">抹去分</el-radio>
                                        <el-radio label="unity"
                                        >统一修改为xx.
                                            <el-input-digit
                                                v-model.number="row.marketPrice.formulaValue.centDime1"
                                                :precision="0"
                                                :min="0"
                                                :maxlength="1"
                                                nullable
                                                style="width: 30px"
                                            >
                                            </el-input-digit>
                                            <el-input-digit
                                                v-model.number="row.marketPrice.formulaValue.centDime2"
                                                :precision="0"
                                                :min="0"
                                                :maxlength="1"
                                                nullable
                                                style="width: 30px"
                                            >
                                            </el-input-digit>
                                            <!-- <el-input
                                                v-model.number="row.marketPrice.formulaValue.centDime"
                                                regexp="^[0-9]{0,2}$"
                                                :maxlength="2"
                                                style="width: 60px"
                                            >
                                            </el-input> -->
                                            元
                                        </el-radio>
                                    </el-radio-group>
                                    </span>
                                </el-form-item>
                                </template>
                            </el-form>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                prop="shop"
                width="350px"
            >
                <template slot="header">
                    <span style="color:#ff3333;">*</span>适配店铺
                </template>
                <template slot-scope="{row}">
                    <div style="display: flex;flex-wrap: wrap;">
                        <template v-for="(shop,index) in row.shopNames">
                            <div class="shop-item" :key="index" >
                                <img :src="getPLATFORMS.icon" class="shop-icon" />
                                <span>{{shop}}</span>
                            </div> 
                        </template>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                prop="opt"
                label="操作"
                width="150px"
            >
                <template slot-scope="{row,$index}">
                    <el-button size="mini" @click="handleDelete(row,$index)">删除</el-button>
                    <el-button type="primary" size="mini" @click="handleEdit(row,$index)" class="is-plain">编辑</el-button>
                </template>
            </el-table-column>
        </el-table>
        <AddShopConfDialog ref="addShopConfDialog" @addShopConf="addShopConf" :platform="platform" :priceConfName="priceConfName" />
        <el-dialog
            title="提示"
            :visible.sync="tipsDialogVisible"
            width="500px"
        >
            <div >
                <div style="font-size: 16px;font-weight:bold;">
                    <i class="el-icon-warning" style="color: #dca550; font-size: 18px"></i>
                    以下店铺已关联价格配置，是否跳过或解除原有关联后绑定新配置？
                </div>
                <div style="margin-top: 16px;display: flex;flex-wrap: wrap;">
                    <div 
                        v-for="(item,index) in bindShops"
                        :key="index"
                        class="shop-item"
                    >
                        <el-image :src="getPLATFORMS.icon" fit="fill" class="shop-icon"></el-image>
                        {{item.shortTitle || item.title}}
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="tipsDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="handleSure('jump')">跳过</el-button>
                <el-button type="primary" @click="handleSure('bindNewSet')">绑定新配置</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import CommPriceConf from '../CommPriceConf.vue'
import AddShopConfDialog from './AddShopConf.vue'
import { PLATFORMS } from '@/dictionary/platforms';
import { cloneDeep } from 'lodash'
export default {
  props: {
    platform: String,
    priceConfName:{
      type:Object,
      default:()=> {}
    },
    shopPriceConf: {
      type: Array,
      default: () => [],
    },
  },
  components:{
    CommPriceConf,
    AddShopConfDialog
  },
  computed:{
    ...mapGetters(['isDistributor']),
    getPLATFORMS(){
        return PLATFORMS[this.platform]
    },
    getPlatformShops(){
        if(this.platform === 'fxg') {
            const shopList = this.$store.getters.get_AllShops_BySource('fxg');
            const fxg_gxShopList = this.$store.getters.get_AllShops_BySource('fxg_gx');
            return [...shopList, ...fxg_gxShopList];
        }
        return this.$store.getters.get_AllShops_BySource(this.platform)
    },
    getShowTableData(){
        return this.tableData.filter(item => !item.isHidden)
    }
  },
  data() {
    return {
      tipsDialogVisible:false,
      selectShop:'',
      tableData:[],
      bindShops:[],
      addShopConfData:{}
    };
  },
  watch: {
    shopPriceConf: {
      handler(v) {
        const list = cloneDeep(v)
        let shopConf = list.map((item,index) => {
            let confList = item.confList;
            let obj = {
                id:item.shopIds.join('_'),
                expand:index === 0 ? true : false,
                shopIds:item.shopIds,
                shopNames:item.shopNames,
                isIncr: false,
                salesPrice: {
                    type: 'sales',
                    way: 'unity',
                    incr: '',
                    formulaValue: {
                        priceMultiplier: 'now',
                        formula: 'reserve',
                        percentage: 100,
                        addValue: 0,
                        subtractionValue: 0,
                        centDime: '',
                    },
                    supplyFormulaValue:{
                        priceMultiplier: 'now',
                        formula: 'reserve',
                        percentage: 100,
                        addValue: 0,
                        subtractionValue: 0,
                        centDime: '',
                    },
                    isCalculateFreight:false, // 分销商品价格是否附加供销运费
                },
                marketPrice: {
                type: 'market',
                way: 'unity',
                incr: '',
                formulaValue: {
                    priceMultiplier: 'now',
                    formula: 'reserve',
                    percentage: 100,
                    addValue: 0,
                    subtractionValue: 0,
                    centDime: '',
                },
                },
            };
            confList.forEach((c) => {
                let centDime = c?.formulaValue?.centDime || 0;
                let centDime1 = 0
                let centDime2 = 0
                if(typeof centDime === 'number'){
                    if(centDime < 10){
                        centDime1 = 0
                        centDime2 = centDime
                    }else{
                        centDime1 = Math.floor(centDime / 10)
                        centDime2 = centDime % 10
                    }
                }
                c.formulaValue = {
                    priceMultiplier: 'now',
                    formula: 'reserve',
                    percentage: 100,
                    addValue: 0,
                    subtractionValue: 0,
                    centDime: '',
                    ...c.formulaValue,
                    centDime1,
                    centDime2,
                }
                if (c.type === 'sales') {
                    obj.salesPrice = {
                        ...obj.salesPrice,
                        ...c,
                        isCalculateFreight:!!c.isCalculateFreight
                    };
                    obj.isIncr = !!obj.salesPrice.incr;
                } else if (c.type === 'market') {
                    obj.marketPrice = {
                        ...obj.marketPrice,
                        ...c,
                    };
                }
            });
            return obj;
        });
        this.tableData = [...shopConf]
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    handlerExpand(row){
        let list = this.tableData
        list.forEach(item => {
            if(row.id === item.id){
                item.expand = !item.expand
            }else{
                item.expand = false
            }
        })
        this.tableData = [...list]
    },
    handlerAddConf(){
        this.$refs.addShopConfDialog.openDialog();
    },
    addShopConf(conf,editIndex){
        this.addShopConfData = {};
        let obj = {
            id:conf.shopIds.join('_'),
            expand:this.tableData.length === 0 ? true : false,
            shopIds:conf.shopIds,
            shopNames:conf.shopNames,
            isIncr: !!conf.confList[0]?.incr,
        }
        if(conf.confList[0]){
            obj.salesPrice = {...conf.confList[0]}
        }
        if(conf.confList[1]){
            obj.marketPrice = {...conf.confList[1]}
        }
        let shopMap = {};
        let bindShop = [];
        this.getPlatformShops.forEach(item => {
            shopMap[item.id] = item
        })
        this.tableData.forEach((item, index)=> {
            conf.shopIds.forEach(shopId => {
                if(typeof editIndex !== 'number' || index !== editIndex){ // 编辑的行不做重复校验
                    if(item.shopIds.includes(shopId)){
                        bindShop.push(shopMap[shopId])
                    }
                }
            })
        });
        this.bindShops = [...bindShop];
        if(bindShop.length){
            this.tipsDialogVisible = true;
            this.addShopConfData = {...obj};
            return;
        }
        if(typeof editIndex === 'number'){// 编辑就直接替换数据
            this.tableData.splice(editIndex,1,obj);
        }else{
            this.tableData.push(obj);
        }
        this.$refs.addShopConfDialog.closeDialog();
    },
    handleShopChange(shopId){
        this.tableData = this.tableData.map(item => {
            let obj = {...item,isHidden:false}
            if(shopId && !item.shopIds.includes(shopId)){
                obj.isHidden = true;
            }
            return {
                ...obj
            }
        });
    },
    getData() {
      const curPlatType = this.priceConfName;
      const list = this.tableData.map(item => {
        let { centDime1:s_centDime1,centDime2:s_centDime2 } = item.salesPrice.formulaValue
        item.salesPrice.formulaValue.centDime = (s_centDime1 || 0) * 10 + (s_centDime2 || 0)
        delete item.salesPrice.formulaValue.centDime1
        delete item.salesPrice.formulaValue.centDime2
        let confList = [{
            ...item.salesPrice,
            incr: item.isIncr ? item.salesPrice.incr : 0,
            isCalculateFreight:item.salesPrice.isCalculateFreight ? 1 : 0,
            supplyFormulaValue:{
                ...item.salesPrice.supplyFormulaValue,
                addValue:item.salesPrice?.supplyFormulaValue?.addValue || 0,
                subtractionValue:item.salesPrice?.supplyFormulaValue?.subtractionValue || 0,
                percentage:item.salesPrice?.supplyFormulaValue?.percentage || 100,
                formula: item.salesPrice?.supplyFormulaValue?.formula || 'reserve',
            }
        }];
        if (curPlatType.market) {
            let { centDime1:m_centDime1,centDime2:m_centDime2 } = item.marketPrice.formulaValue
            item.marketPrice.formulaValue.centDime = (m_centDime1 || 0) * 10 + (m_centDime2 || 0)
            delete item.marketPrice.formulaValue.centDime1
            delete item.marketPrice.formulaValue.centDime2
            confList.push({...item.marketPrice});
        }
        return {
          shopIds: [...item.shopIds],
          shopNames:[...item.shopNames],
          confList
        };
      })
      return list;
    },
    handleSure(type){
        let obj = { ...this.addShopConfData };
        let _tableData = cloneDeep(this.tableData);
        if(type === 'jump'){
            this.bindShops.forEach(item => {
                obj.shopIds = obj.shopIds.filter(id => id !== item.id)
                obj.shopNames = obj.shopNames.filter(name => name !== item.title)
            });
            if(obj.shopIds.length === 0){
                this.$message.error('跳过后没有店铺可以绑定，请重新选择店铺后再操作！');
                return;
            }
            obj.id = obj.shopIds.join('_');
            this.tableData.push(obj);
            this.tipsDialogVisible = false
            this.$refs.addShopConfDialog.closeDialog();
        }else if(type === 'bindNewSet'){
            this.bindShops.forEach(shop => {
                _tableData.forEach((item,index) => {
                    if(item.shopIds.includes(shop.id)){
                        item.shopIds = item.shopIds.filter(id => id !== shop.id)
                        item.shopNames = item.shopNames.filter(name => name !== shop.title)
                        item.id = item.shopIds.join('_');
                        if(item.shopIds.length === 0){
                            _tableData.splice(index,1)
                        }
                    }
                })
            });
            _tableData.push(obj);
            this.tableData = [..._tableData]
            this.tipsDialogVisible = false
            this.$refs.addShopConfDialog.closeDialog();
        }
        console.log('this.tableData:',this.tableData)
    },
    handleEdit(row,index){
        this.$refs.addShopConfDialog.openDialog(row,index);
    },
    handleDelete(row,index){
        this.$confirm('是否继续删除此配置?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          width: '500px',
        }).then(() => {
            this.tableData.splice(index,1);
        }).catch(() => {});
    },
  },
};
</script>

<style lang="scss">
.shopConfWrap{
    width: 1201px;
    .shopConItem{
        .shopConExpandBtn{
            padding: 8px;
        }
    }
    .shop-item + .shop-item{
        margin-left: 8px;
    }
    .shopConExpandBtn{
        cursor: pointer;
        color: #409EFF;
    }
}
.shop-item{
    display: flex;
    align-items: center;
    font-size: 14px;
    .shop-icon{
        width:18px;
        height: 18px;
        margin-right: 5px;
    }
}
</style>